<template>
  <div class="pax-count-input">
    <div class="block">
      <div class="texts">
        <div
          v-dompurify-html="title"
          class="title"
        />
        <div
          v-if="subtitle"
          class="subtitle"
        >
          {{ subtitle }}
        </div>
      </div>
      <div class="actions">
        <pax-input-horizontal
          :value="value"
          :min-value="minValue"
          :max-value="maxValue"
          :parent-count="parentCount"
          @setValue="setValue"
        />
      </div>
    </div>
    <div
      v-if="errorMessage"
      class="block"
    >
      <div class="info-block">
        <div
          v-dompurify-html="errorMessage"
          class="message"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import PaxInputHorizontal from 'components/eHorizon/PaxSelector/PaxInputHorizontal'
  const events = {
    SET_VALUE: 'setValue'
  }

  export default {
    components: {
      PaxInputHorizontal
    },
    props: {
      title: {
        type: String,
        required: true
      },
      subtitle: {
        type: String,
        default: '',
        required: false
      },
      value: {
        type: Number,
        required: true
      },
      minValue: {
        type: Number,
        required: true
      },
      maxValue: {
        type: Number,
        required: true
      },
      errorMessage: {
        type: String,
        required: false,
        default: ''
      },
      parentCount: {
        type: Number,
        default: 1,
        required: false
      }
    },
    methods: {
      setValue (value) {
        this.$emit(events.SET_VALUE, value)
      }
    }
  }
</script>


<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .pax-count-input {
    display: flex;
    flex-direction: column;
    align-items: center;


    @include bp-mf-tablet {
      background-color: #ffffff;
      margin: 0;
    }
  }

  .block {
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    position: relative;
    text-align: left;
    align-items: center;
    width: 100%;

    @include bp-mf-tablet {
      padding: 0;
    }

    @include bp-mf-desktop {
      margin-bottom: 14px;
    }
  }

  .texts {
    display: flex;
    flex-direction: column;
    margin-right: 5px;
    max-width: calc(100% - 101px);
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;

    .title {
      word-break: break-all;
      color: $grey-default;
      font-size: em(16);
      line-height: 19px;
      @include text-overflow
    }

    .subtitle {
      word-break: break-word;
      color: $input-placeholder;
      font-size: em(12);
      line-height: 14px;
      margin-top: 6px;

      @include bp-mf-desktop {
        margin-top: 2px;
      }
    }
  }

  .info-block {
    border: 1px solid hexToRGBA(#000000, 0.08);
    border-radius: 3px;
    background-color: $light-yellow;
    padding: 13px 8px 11px;
    word-break: break-word;
    display: flex;
    justify-content: center;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;

    @include bp-mf-desktop {
      margin: 0 -8px;
    }

    .message {
      font-size: em(13);
      line-height: 20px;
      text-align: center;

      ::v-deep p {
        margin: 0;
      }

      ::v-deep a {
        color: $blue-medium;
      }
    }
  }

</style>
